export const renderEmdAssetBlock = (references,node) => {
    //console.log(references, node);

    const id = node.data.target.sys.id;
    const reference = references.find((reference) => reference.contentful_id === id);

    return reference;
}
